import { CACHE_PROFILES } from "@/config/query-cache"
import { useTransportQuery } from "@/transport"

import type { TransportOperationRequest } from "@/types_api/backend/transport/operations"

type RunsPageInsightsRequest = TransportOperationRequest<"getRunsPageInsights">

const RUNS_INSIGHTS_STALE_TIME_MS = 30 * 1000

export function useRunsPageInsightsTransport({
  enabled,
  refetchInterval,
  request,
}: {
  enabled: boolean
  refetchInterval?: number | false
  request: RunsPageInsightsRequest | null
}) {
  return useTransportQuery({
    operation: "getRunsPageInsights",
    request,
    options: {
      ...CACHE_PROFILES.standard,
      enabled,
      abortOnUnmount: true,
      refetchInterval,
      refetchOnWindowFocus: false,
      staleTime: RUNS_INSIGHTS_STALE_TIME_MS,
    },
  })
}
